<script lang="ts">
	export let checked = false
	export let disabled = false
</script>

<label class="switch">
	<input type="checkbox" bind:checked {disabled} />
	<span class="slider"></span>
</label>

<style>
	.switch {
		position: relative;
		display: inline-block;
		width: 38px;
		height: 20px;
		margin: 0;
	}

	.switch input {
		opacity: 0;
		width: 0;
		height: 0;
	}

	.slider {
		position: absolute;
		cursor: pointer;
		inset: 0 0 0 0;
		background-color: #ccc;
		transition: 0.4s;
		border-radius: 20px;
	}

	.slider::before {
		position: absolute;
		content: '';
		height: 16px;
		width: 16px;
		left: 2px;
		bottom: 2px;
		background-color: white;
		transition: 0.4s;
		border-radius: 50%;
	}

	input:checked + .slider {
		background-color: #58c079;
	}

	input:checked + .slider {
		box-shadow: 0 0 1px #58c079;
	}

	input:checked + .slider::before {
		transform: translateX(18px);
	}
</style>
